import { render, staticRenderFns } from "./DistributionListExt.vue?vue&type=template&id=812ee40e&scoped=true&"
import script from "./DistributionListExt.vue?vue&type=script&lang=js&"
export * from "./DistributionListExt.vue?vue&type=script&lang=js&"
import style0 from "./DistributionListExt.vue?vue&type=style&index=0&id=812ee40e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812ee40e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VContainer,VDataTable,VDivider})
